/**
 * ActiveCampaign sync activity client (#682).
 *
 * Two GET-only reads over `apps.sync_bridge.activity` — the run-by-run feed of
 * what the hourly push (and waves / contact creation) wrote, and one person's
 * current mirrored values + history. Nothing here can write: there is no
 * action on this surface by design (pausing the push is David-only, in
 * `production.env`, runbook §10.0). No trailing slash — matches
 * `apps.sync_bridge.urls`.
 */
import { apiRequest } from "./client";
import type {
  ActivityQuery,
  ActivityResponse,
  MemberActivityResponse,
} from "./syncActivity.types";

export function buildActivityQuery(query: ActivityQuery = {}): string {
  const params = new URLSearchParams();
  if (query.since) params.set("since", query.since);
  if (query.until) params.set("until", query.until);
  if (query.field) params.set("field", query.field);
  if (query.member != null) params.set("member", String(query.member));
  if (query.q) params.set("q", query.q);
  if (query.includeQuiet) params.set("include_quiet", "1");
  if (query.offset) params.set("offset", String(query.offset));
  if (query.limit) params.set("limit", String(query.limit));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

/** `GET /api/sync-bridge/activity?since&until&field&member&q&include_quiet&offset&limit`. */
export function getSyncActivity(query: ActivityQuery = {}): Promise<ActivityResponse> {
  return apiRequest<ActivityResponse>(`/sync-bridge/activity${buildActivityQuery(query)}`);
}

/** `GET /api/sync-bridge/activity/member/<id>` — one person's AC values + history. */
export function getMemberSyncActivity(memberId: number | string): Promise<MemberActivityResponse> {
  return apiRequest<MemberActivityResponse>(
    `/sync-bridge/activity/member/${encodeURIComponent(String(memberId))}`,
  );
}
